import {
    Edit,
    SimpleForm,
    TextInput,
    required,
} from 'react-admin';
import { NokEmailSignatureCodeEditor } from '../code-editor/NokEmailSignatureCodeEditor';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const NokEmailSignatureEdit = () => {

    // HQ-07. Two arrays of instruction and variable copy used to be built here and passed
    // to the editor as `instructions` and `variables`. The editor declares no props, so they
    // were discarded - and it renders its own copies of the same text, which is why nobody
    // noticed. The editor's copy is the one that has always been on screen, so the dead
    // arrays go rather than the rendered ones. Add a props type to the editor if the copy
    // ever needs to differ per screen.

    return (
        <Edit redirect={ false }>
            <SimpleForm  >
                <TextInput source="name" validate={[required()]} />
                <NokEmailSignatureCodeEditor />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
